import { useSnackbar } from 'notistack';
import { forwardRef } from 'react';
import { useSnackbarHoverProgressTimer } from '../../hooks/use-snackbar-hover-progress-timer';
import { ProgressSnackbarContent } from './progress-snackbar-content';
import type { ProgressSnackbarProps as Props } from './types';

/**
 * Progress snackbar for timer-based auto-hide countdown.
 * Uses the hover progress timer to show countdown from 100% to 0%.
 */
export const TimerProgressSnackbar = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { id, title, icon, message, autoHideDuration, ...other } = props;
    const { closeSnackbar } = useSnackbar();

    const {
      handleMouseEnter,
      handleMouseLeave,
      progress: timerProgress,
    } = useSnackbarHoverProgressTimer(autoHideDuration, () => {
      closeSnackbar(id);
    });

    return (
      <ProgressSnackbarContent
        ref={ref}
        id={id}
        title={title}
        icon={icon}
        message={message}
        progressValue={timerProgress}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="ProgressSnackbar"
        {...other}
      />
    );
  }
);

TimerProgressSnackbar.displayName = 'TimerProgressSnackbar';
